import React from 'react';
import { setRedirectError } from '../redirectError/redirectErrorSlice';
import { incrementBaasStep } from '../baasSignup/baasSignupSlice';
import { useDispatch, useSelector } from 'react-redux';
import Hmi, { HmiType } from 'hmi';
import 'hmi/dist/hmi.cjs.development.css';
import { selectDependencyApps, selectDependencyTools, selectParentApp } from './hmiSlice';
import { LoadingScreen } from '../../components/shared/LoadingScreen/LoadingScreen';

export const HmiBaas: React.FC = () => {
  const parentApp = useSelector(selectParentApp);
  const dependencyApps = useSelector(selectDependencyApps);
  const dependencyTools = useSelector(selectDependencyTools);
  const dispatch = useDispatch();

  if (
    !parentApp ||
    (parentApp.setup.dependencies && parentApp.setup.dependencies?.length !== dependencyApps.length) ||
    (parentApp.dependencies && parentApp.dependencies.tools.length !== dependencyTools.length)
  ) {
    return <LoadingScreen messageId={'hatters.signup.loading'} />;
  }

  return (
    <>
      <Hmi
        applicationId={parentApp.id}
        hmiType={HmiType.registration.baas}
        parentApp={parentApp}
        dependencyApps={dependencyApps}
        dependencyTools={dependencyTools.map((tool) => tool.info.name)}
        onApproved={() => dispatch(incrementBaasStep(2))}
        onRejected={() =>
          dispatch(
            setRedirectError({
              error: 'user_cancelled',
              reason: 'permissions_denied',
            }),
          )
        }
      />
    </>
  );
};
